<div class="db-blocker-screen">
  <div><i class="db-icon db-icon-settings db-blocker-screen__icon"></i></div>
  <div class="db-blocker-screen__content"><ng-content></ng-content></div>
</div>
